/* eslint-disable camelcase */

import { SWRConfiguration } from "swr";
import { UsersDomain } from "./members";
import { ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosHVS";

export interface MeApiResponse<T> {
  data: T;
}

export const useMe = (
  config?: SWRConfiguration
): ServerResponse<MeApiResponse<UsersDomain>> =>
  useSwr<MeApiResponse<UsersDomain>>(`/me`, config);
